export enum SyncOperation {
    Create = 'create',
    Update = 'update',
    Delete = 'delete'
}
